import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  fullWidth?: boolean;
  href?: string;
  trackValue?: number;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  href,
  trackValue,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg shadow-sm';
  const variants = {
    primary: 'bg-emerald-600 hover:bg-emerald-700 text-white focus:ring-emerald-500 border border-transparent',
    secondary: 'bg-amber-500 hover:bg-amber-600 text-white focus:ring-amber-500 border border-transparent',
    outline: 'bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300 focus:ring-gray-500',
    danger: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500 border border-transparent'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} onClick={e => {
    if (href) {
      // Fire Meta Pixel AddToCart event
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          value: trackValue ?? 290,
          currency: 'UYU',
          content_name: 'El Protocolo de Limpieza Glicémica',
          content_type: 'product'
        });
      }
      window.location.href = href;
    }
    props.onClick?.(e);
  }} {...props} data-id="element-374">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-375" />}
      {children}
    </button>;
}